import React from 'react'

export const translations = {
  // Common
  appTitle: {
    en: 'Church - Workflow',
    zh: '教會 - 工作流程'
  },
  appSubtitle: {
    en: 'sam-church-workflow',
    zh: 'sam-church-workflow'
  },
  login: {
    en: 'Login',
    zh: '登入'
  },
  logout: {
    en: 'Logout',
    zh: '登出'
  },
  save: {
    en: 'Save',
    zh: '儲存'
  },
  submit: {
    en: 'Submit',
    zh: '提交'
  },
  cancel: {
    en: 'Cancel',
    zh: '取消'
  },
  edit: {
    en: 'Edit',
    zh: '編輯'
  },
  delete: {
    en: 'Delete',
    zh: '刪除'
  },
  create: {
    en: 'Create',
    zh: '建立'
  },
  update: {
    en: 'Update',
    zh: '更新'
  },
  search: {
    en: 'Search',
    zh: '搜尋'
  },
  loading: {
    en: 'Loading...',
    zh: '載入中...'
  },
  success: {
    en: 'Success',
    zh: '成功'
  },
  error: {
    en: 'Error',
    zh: '錯誤'
  },
  required: {
    en: 'Required',
    zh: '必填'
  },
  optional: {
    en: 'Optional',
    zh: '選填'
  },

  // Authentication
  username: {
    en: 'Username',
    zh: '用戶名稱'
  },
  password: {
    en: 'Password',
    zh: '密碼'
  },
  loginSuccess: {
    en: 'Login successful',
    zh: '登入成功'
  },
  loginFailed: {
    en: 'Login failed',
    zh: '登入失敗'
  },
  invalidCredentials: {
    en: 'Invalid username or password',
    zh: '用戶名稱或密碼錯誤'
  },
  pleaseLogin: {
    en: 'Please log in',
    zh: '請登入'
  },

  // User roles
  roleUser: {
    en: 'User',
    zh: '一般用戶'
  },
  roleAdmin: {
    en: 'Admin',
    zh: '管理員'
  },
  roleSysAdmin: {
    en: 'System Admin',
    zh: '系統管理員'
  },
  roleViewer: {
    en: 'View-only',
    zh: '唯讀用戶'
  },

  // Churches
  church: {
    en: 'Church',
    zh: '堂會'
  },
  churches: {
    en: 'Churches',
    zh: '堂會'
  },
  KTC: {
    en: 'KTC',
    zh: '觀塘堂'
  },
  SSC: {
    en: 'SSC',
    zh: '上水堂'
  },
  WIC: {
    en: 'WIC',
    zh: '西環堂'
  },
  STC: {
    en: 'STC',
    zh: '沙田堂'
  },

  // Entry types
  type: {
    en: 'Type',
    zh: '類型'
  },
  sermon: {
    en: 'Sermon',
    zh: '講道'
  },
  sundaySchool: {
    en: 'Sunday School',
    zh: '主日學'
  },
  event: {
    en: 'Event',
    zh: '活動'
  },

  // Entry fields
  title: {
    en: 'Title',
    zh: '標題'
  },
  eventDate: {
    en: 'Event Date',
    zh: '活動日期'
  },
  eventDatePlaceholder: {
    en: 'YYYYMMDD',
    zh: 'YYYYMMDD'
  },
  time: {
    en: 'Time',
    zh: '時間'
  },
  timePlaceholder: {
    en: 'HH:MM',
    zh: 'HH:MM'
  },
  speaker: {
    en: 'Speaker',
    zh: '講員'
  },
  scripture: {
    en: 'Scripture',
    zh: '經文'
  },
  youtubeUrl: {
    en: 'YouTube URL',
    zh: 'YouTube 連結'
  },
  zoomUrl: {
    en: 'Zoom URL',
    zh: 'Zoom 連結'
  },
  zoomMeetingInfo: {
    en: 'Zoom Meeting Info',
    zh: 'Zoom 會議資訊'
  },
  description: {
    en: 'Description',
    zh: '描述'
  },
  files: {
    en: 'Files',
    zh: '檔案'
  },
  uploadFiles: {
    en: 'Upload Files',
    zh: '上傳檔案'
  },
  lastUpdated: {
    en: 'Last Updated',
    zh: '最後更新'
  },
  updatedBy: {
    en: 'Updated By',
    zh: '更新者'
  },

  // Status
  status: {
    en: 'Status',
    zh: '狀態'
  },
  saved: {
    en: 'Saved',
    zh: '已儲存'
  },
  submitted: {
    en: 'Submitted',
    zh: '已提交'
  },
  inProgress: {
    en: 'In Progress',
    zh: '進行中'
  },
  completed: {
    en: 'Completed',
    zh: '已完成'
  },
  noSubmission: {
    en: 'No Submission',
    zh: '尚未提交'
  },

  // Admin page
  overview: {
    en: 'Overview',
    zh: '總覽'
  },
  allEvents: {
    en: 'All Sermons & Sunday Schools',
    zh: '所有講道／主日學'
  },
  eventsOverview: {
    en: 'Events Overview',
    zh: '活動總覽'
  },
  upcomingEvents: {
    en: 'Active / Upcoming',
    zh: '進行中／即將舉行'
  },
  pastEvents: {
    en: 'Ended (30 days)',
    zh: '已結束（30天內）'
  },
  noUpcomingEvents: {
    en: 'No active or upcoming events',
    zh: '暫無進行中或即將舉行的活動'
  },
  seePastEventsHint: {
    en: 'Tip: older events may be under “Ended”.',
    zh: '提示：活動日期已過但仍在刊登期內會顯示於此；已結束請點「已結束」。'
  },
  postToMain: {
    en: 'Post to church main page',
    zh: '上載堂會主頁'
  },
  postUntil: {
    en: 'Post until',
    zh: '刊登至'
  },
  eventPoster: {
    en: 'Event poster',
    zh: '活動 Poster'
  },
  videoUrl: {
    en: 'Event video URL',
    zh: '活動錄影 URL'
  },
  videoUrlSuggest: {
    en: 'Suggested URL',
    zh: '建議 URL'
  },
  acceptSuggestedUrl: {
    en: 'Accept',
    zh: '採用'
  },
  timeStart: {
    en: 'Start time',
    zh: '開始時間'
  },
  timeEnd: {
    en: 'End time',
    zh: '結束時間'
  },
  yes: {
    en: 'Yes',
    zh: '是'
  },
  no: {
    en: 'No',
    zh: '否'
  },
  posterUploading: {
    en: 'Uploading & compressing poster…',
    zh: '正在上傳並壓縮 Poster…'
  },
  posterReady: {
    en: 'Poster ready (1280×720)',
    zh: 'Poster 已就緒（1280×720）'
  },
  posterHint: {
    en: 'jpg / png / gif / webp / bmp / tiff — center-cropped to 16:9 at 1280×720 JPEG (GIF uses first frame)',
    zh: '支援 jpg / png / gif / webp / bmp / tiff — 會置中裁切為 16:9、1280×720 JPEG（GIF 取第一幀）'
  },
  removePoster: {
    en: 'Remove poster',
    zh: '移除 Poster'
  },
  recentEvents: {
    en: 'Recent Events',
    zh: '近期活動'
  },
  viewAll: {
    en: 'View All',
    zh: '查看所有'
  },
  copyText: {
    en: 'Copy text',
    zh: '複製文字'
  },
  copyTextSlow: {
    en: 'Copy text (~30s)',
    zh: '複製文字 (~30秒)'
  },
  copyTextAll: {
    en: 'Copy Text - All',
    zh: '複製文字 - 全部'
  },
  youtubeNotReady: {
    en: 'YouTube link not ready',
    zh: 'YouTube 連結尚未就緒'
  },
  refreshYoutube: {
    en: 'Refresh YouTube link',
    zh: '重新抓取 YouTube 連結'
  },
  refreshingYoutube: {
    en: 'Refreshing…',
    zh: '更新中…'
  },
  showRecent: {
    en: 'Show recent',
    zh: '顯示近期'
  },
  showDefault: {
    en: 'Show default',
    zh: '顯示預設'
  },
  weeksToShow: {
    en: 'Weeks',
    zh: '顯示週數'
  },
  weeksAll: {
    en: 'All',
    zh: '全部'
  },
  notSundayWarning: {
    en: '⚠️ Not a Sunday',
    zh: '⚠️ 非週日'
  },

  // User management (SysAdmin)
  users: {
    en: 'User Management',
    zh: '用戶管理'
  },
  addUser: {
    en: 'Add User',
    zh: '新增用戶'
  },
  editUser: {
    en: 'Edit User',
    zh: '編輯用戶'
  },
  deleteUserConfirm: {
    en: 'Are you sure you want to delete this user?',
    zh: '確定要刪除此用戶？'
  },
  userCreated: {
    en: 'User created successfully',
    zh: '用戶建立成功'
  },
  userUpdated: {
    en: 'User updated successfully',
    zh: '用戶更新成功'
  },
  userDeleted: {
    en: 'User deleted successfully',
    zh: '用戶刪除成功'
  },

  // Entry form
  newEntry: {
    en: 'New Entry',
    zh: '新增條目'
  },
  editEntry: {
    en: 'Edit Entry',
    zh: '編輯條目'
  },
  entrySaved: {
    en: 'Entry saved successfully',
    zh: '條目已儲存'
  },
  entrySubmitted: {
    en: 'Entry submitted successfully',
    zh: '條目已提交'
  },

  // Lock warning
  lockWarning: {
    en: 'This entry is being edited by',
    zh: '此條目正在被編輯'
  },
  takeOver: {
    en: 'Take Over',
    zh: '接管編輯'
  },
  unlockFirst: {
    en: 'Unlock First',
    zh: '先解鎖'
  },

  // Navigation
  home: {
    en: 'Data Entry',
    zh: '資料輸入'
  },
  events: {
    en: 'Events',
    zh: '活動面板'
  },
  adminPanel: {
    en: 'Weekly Overview',
    zh: '每週總覽'
  },
  ministryReport: {
    en: 'Ministry Report',
    zh: '家事報告'
  },
  sysAdminPanel: {
    en: 'System Admin',
    zh: '系統管理面板'
  },

  // Validation
  titleRequired: {
    en: 'Title is required',
    zh: '標題為必填'
  },
  titleTooLong: {
    en: 'Title must be 15 characters or less',
    zh: '標題不得超過15個字'
  },
  dateRequired: {
    en: 'Event date is required',
    zh: '活動日期為必填'
  },
  dateInvalid: {
    en: 'Invalid date format (use YYYYMMDD)',
    zh: '日期格式錯誤（使用YYYYMMDD）'
  },
  timeInvalid: {
    en: 'Invalid time format (e.g. 9:30 or 09:30)',
    zh: '時間格式錯誤（例如 9:30 或 09:30）'
  },
  descriptionTooLong: {
    en: 'Description must be 255 characters or less',
    zh: '描述不得超過255字'
  },
  fileTooLarge: {
    en: 'File exceeds maximum size (50MB)',
    zh: '檔案超過大小限制（50MB）'
  },
  fileTypeError: {
    en: 'Invalid file type. Allowed: pdf, ppt, pptx, doc, docx, txt, md',
    zh: '檔案類型錯誤。允許：pdf, ppt, pptx, doc, docx, txt, md'
  },

  // Dashboard
  welcome: {
    en: 'Welcome',
    zh: '歡迎'
  },
  myEntries: {
    en: 'My Entries',
    zh: '我的條目'
  },
  systemLogs: {
    en: 'System Logs',
    zh: '系統日誌'
  },
  action: {
    en: 'Action',
    zh: '操作'
  },
  timestamp: {
    en: 'Timestamp',
    zh: '時間'
  },
  details: {
    en: 'Details',
    zh: '詳情'
  },

  // Multi-church
  selectChurches: {
    en: 'Select Churches',
    zh: '選擇堂會'
  },
  atLeastOneChurch: {
    en: 'At least one church is required',
    zh: '至少需要選擇一個堂會'
  },
  yourChurches: {
    en: 'Your Churches',
    zh: '您負責的堂會'
  },

  // Day of week
  daySun: {
    en: 'Sun',
    zh: '日'
  },
  dayMon: {
    en: 'Mon',
    zh: '一'
  },
  dayTue: {
    en: 'Tue',
    zh: '二'
  },
  dayWed: {
    en: 'Wed',
    zh: '三'
  },
  dayThu: {
    en: 'Thu',
    zh: '四'
  },
  dayFri: {
    en: 'Fri',
    zh: '五'
  },
  daySat: {
    en: 'Sat',
    zh: '六'
  }
}

// Get translation
export function t(key, lang = 'zh') {
  if (!translations[key]) {
    console.warn(`Translation key not found: ${key}`)
    return key
  }
  return translations[key][lang] || translations[key]['zh'] || key
}

// Language context
export const LanguageContext = React.createContext({
  lang: 'zh',
  setLang: () => {}
})

export function useLanguage() {
  return React.useContext(LanguageContext)
}